module.exports = __webpack_public_path__ + "img/skeleton-king.1d9580bc.svg";